import { FC } from 'react';
import { useGetPayRunHistoryQuery } from '../api';
import Timeline from 'containers/accounting/pay-runs/components/Timeline';
import { BackIcon } from 'assets/icons';
import { Loader, SidePanel } from 'components';
import { useNavigate, useParams } from 'react-router-dom';

interface PayPeriodRecentActivityProps {
  className?: string;
}

const PayPeriodRecentActivity: FC<PayPeriodRecentActivityProps> = ({ className }) => {
  const navigate = useNavigate();

  const { teamId, payRunId } = useParams();

  const { data: historyData, isFetching } = useGetPayRunHistoryQuery({ teamId, payRunId });

  const onClose = () => {
    navigate(-1);
  };

  return (
    <SidePanel isOpen={true} onClose={onClose}>
      <div className="flex h-full w-96 flex-col bg-white">
        {/* Header */}
        <div className="flex items-center gap-4 border-b border-[#ECF1F7] p-4">
          <BackIcon className="h-5 w-5 cursor-pointer stroke-secondary stroke-2" onClick={onClose} />
          <h3 className="text-17px font-semibold text-primaryText">History</h3>
        </div>

        {isFetching && <Loader />}

        {!isFetching && historyData?.events && historyData.events.length > 0 && (
          <Timeline
            events={historyData.events}
            timelineId="pay-period-recent-activity"
            timelineClassName="max-h-[600px]"
            titleClassName="text-17px font-semibold text-primaryText"
            subTitleClassName="text-sbase font-medium text-primaryText"
            subTextClassName="text-sbase text-accentText"
          />
        )}

        {!isFetching && (!historyData?.events || historyData.events.length === 0) && (
          <div className="flex h-full items-center justify-center text-accentText">No events to display</div>
        )}
      </div>
    </SidePanel>
  );
};

export default PayPeriodRecentActivity;
